// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner___3Ek4M","proImg":"proImg___29e37"};